export const ADMIN_SESSION_APPLICATION_ID_KEY = 'admin_session_application_id';
